// extracted by css-extract-rspack-plugin
export default {"cls1":"SidebarComments-cls1_tQZ","cls2":"SidebarComments-cls2_cbf SidebarComments-cls1_tQZ"};